import firebase from 'firebase'
import { firestore, query, collection, where, getAll } from 'firebase/firestore';
import { db, auth } from '../db';
import Response from './Response';
import Template from './Template';
import Achievements from "./Achievements";
import Events from "./Events";

const PROFILE_DNE = "Profile DNE";

// helper Function
function err(e) {
    return { success: false, error: e };
}

async function getPlayTesterProfile(testerId) {
    /** Get the profile of a PlayTester with a given testerId.
     * Invariants:
     * - testerID is a valid tester ID, that has a valid profile somewhere, or it's blank.
     **/
    return new Promise((resolve, reject) => {
        db.collection("PlayTester").doc(testerId).get()
            .then(profile => {
                if (!profile.exists) {
                    console.error("User doesn't exist. We'll use default data but be careful.");
                    return resolve({
                        success: false,
                        data: {
                            age: '',
                            platform: [],
                            behavior: [],
                            gender: '',
                            genre: [],
                            hours: '',
                            profile: [],
                            purchasingBehavior: [],
                            firstTimeUser: [1,1,1,1],
                            testerID: '',
                        },
                    });
                }
                const data = profile.data()
                return resolve({
                    success: true,
                    data: { // FIXME: the ordering is important because of how colours were set up in Attribute Edit. THis is weird and should be refactored.
                        age: data.age || '',
                        platform: data.platform || [],
                        behavior: data.behavior || [],
                        gender: data.gender || '',
                        genre: data.genre || [],
                        hours: data.hours || '',
                        profile: data.profile || [],
                        purchasingBehavior: data.purchasingBehavior || [],
                        firstTimeUser: data.firstTimeUser || [1,1,1,1],
                        testerID: data.testerId || '',
                    }
                });
            }).catch(e => {
                err(e);
            })
            .catch(e => {
                err(e);
            })
    })
}

//AttributeEdit.vue
async function createPlayTesterProfile(testerDetails) {
    const { age, behavior, gender, genre, hours, platform, profile, purchasingBehavior, testerId } = testerDetails;
    console.log("before adding to PlayTester");
    console.log(testerDetails);
    const isPlatformFilled = platform && platform.length > 0;
    const isBehaviorFilled = behavior && behavior.length > 0;
    const isGenreFilled = genre && genre.length > 0;
    const isProfileFilled = profile && profile.length > 0;
    const isPurchasingBehaviorFilled = purchasingBehavior && purchasingBehavior.length > 0;

    // if at least one field from any category is filled, return true.
    const completeProfile = isPlatformFilled || isBehaviorFilled || isGenreFilled || isProfileFilled || isPurchasingBehaviorFilled;
    console.log("infunc");

    return new Promise((resolve, reject) => {
        db.collection("User").doc(testerId).get()
            .then(doc => {
                // check if user exists
                console.log(doc.exists);
                if (!doc.exists) {
                    console.log("user doesn't exist");
                    // return {success: false, message: "user does not exist"};
                    reject({ success: false, error: "user does not exist" });
                }

                if (doc.data().userType !== "tester") {
                    reject({ success: false, error: "user is not a tester" });
                } else {
                    console.log("user is a tester");
                    db.collection("PlayTester").doc(testerId).get()
                        .then(doc => {
                            // check if user exists
                            console.log(doc.exists);
                            if (!doc.exists) {
                                console.log("user doesn't exist");
                                // return {success: false, message: "user does not exist"};
                                reject({ success: false, error: "user does not exist" });
                            }
                            var testerData = doc.data();

                            /* we return this. It is true if achivement is complete AND
                                is not already completed */
                            let isNowComplete = !(testerData.completeProfile) && completeProfile; 
                            testerData.completeProfile = completeProfile;

                            Achievements.setAchievementCount(testerData)
                                .then((achievementCount) => {
                                    //this.$snackbar.showSnackbar("This is an error message!", "red");
                                    return db.collection("PlayTester").doc(testerId).update({
                                        age: age,
                                        platform: platform,
                                        behavior: behavior,
                                        gender: gender,
                                        genre: genre,
                                        hours: hours,
                                        profile: profile,
                                        purchasingBehavior: purchasingBehavior,
                                        testerID: testerId,
                                        completeProfile: completeProfile,
                                        firstTimeUser: [1,1,1,1],
                                        achievementsCompleted: achievementCount,
                                    });
                                })
                                .then(() => {
                                    console.log("PlayTester Attributes added");
                                    resolve({ success: true, achieved: isNowComplete });
                                })
                                .catch((e) => reject(err(e)));
                    });
                }
            }).catch(e => reject(err(e)));
    });
}

async function isPlayTesterProfileCompleted(testerID) {
    try {
        const testerDoc = await db.collection("PlayTester").doc(testerID).get();

        if (!testerDoc.exists) {
            return false; // No document for the testerID means profile is not completed.
        }

        const data = testerDoc.data();

        const isPlatformFilled = data.platform && data.platform.length > 0;
        const isBehaviorFilled = data.behavior && data.behavior.length > 0;
        const isGenreFilled = data.genre && data.genre.length > 0;
        const isProfileFilled = data.profile && data.profile.length > 0;
        const isPurchasingBehaviorFilled = data.purchasingBehavior && data.purchasingBehavior.length > 0;

        // if at least one field from any category is filled, return true.
        return isPlatformFilled || isBehaviorFilled || isGenreFilled || isProfileFilled || isPurchasingBehaviorFilled;
    } catch (error) {
        console.error("Error checking PlayTester profile completion:", error);
        return false;
    }
}

// AddTesterItem.vue
/*
    adds a tester (id testerId) to a game (id gameId) if not a tester for the game already
*/
async function createTester(gameId, testerId) {
    function err(e) {
        return { success: false, error: e };
    }

    return new Promise((resolve, reject) => {
        // check if game exists
        db.collection("Game").doc(gameId).get()
            .then(doc => {
                if (!doc.exists) {
                    reject({ success: false, error: "game does not exist" });
                }

                const gameTesterIDs = doc.data().testerIDs;
                const gameTesterStatuses = doc.data().testerStatuses;

                // if the user exists and is not in the game, add the user to it
                db.collection("User").doc(testerId).get()
                    .then(doc => {
                        if (!doc.exists) { // user doesn't exist, send error
                            console.log("user doesn't exist");
                            reject({ success: false, error: "user does not exist" });
                        }

                        if (gameTesterIDs.includes(doc.id) || doc.data().userType !== "tester") {
                            console.log("user is not a tester or is already in the game");
                            reject({ success: false, error: "user is not a tester or is already in the game" });
                        } else { // user is not in gametesterIDs array, add them
                            db.collection("Game").doc(gameId).update({
                                    testerIDs: [...gameTesterIDs, testerId]
                            }).then(unusedvar => {
                                Events.logEvent("project.joined", { gameId, testerId });
                                //update Playtesters projectsJoined. This can be replaced once playtests are fully implemented
                                db.collection("PlayTester").doc(testerId).get()
                                    .then(doc => {
                                        // check if user exists
                                        console.log(doc.exists);
                                        if (!doc.exists) {
                                            return resolve({ success: true });
                                        }
                                        var testerData = doc.data();
                                        testerData.surveysCompleted += 1;
                                        
                                        Achievements.setAchievementCount(testerData)
                                            .then((achievementCount) => {
                                                db.collection("PlayTester").doc(testerId).update({
                                                    projectsJoined: firebase.firestore.FieldValue.arrayUnion(gameId),
                                                    achievementsCompleted: achievementCount,
                                                });
                                                //assign the tester to all open surveys
                                                Template.getSurveysByGameID(gameId)
                                                    .then(res => {
                                                        let surveys = res.data.filter(survey => survey.status == 1)
                                                        Promise.all(surveys.map(
                                                            survey => Response.assignSurvey(survey.sID, testerId)))
                                                            .then(uuvar => 
                                                                resolve({ success: true})
                                                        )
                                                })
                                            })
                                            .catch((e) => reject(err(e)));
                                });
                                
                                }).catch(e => reject(err(e)));
                        }
                    }).catch(e => reject(err(e)));
            }).catch(e => reject(err(e)));
    });
}

/*
    Check if the playtester is a first-time user
*/
async function updateTesterFirstTime(testerId, index) {
    return new Promise((resolve, reject) => {
      db.collection("PlayTester").doc(testerId).get()
        .then(doc => {
          if (!doc.exists) {
            reject({ success: false, error: "Playtester does not exist" });
          }

          const firstTimeUser = doc.data().firstTimeUser
          firstTimeUser[index] = 0

          db.collection("PlayTester").doc(testerId)
            .update({
              firstTimeUser: firstTimeUser
          }).catch(e => reject(err(e)));
      });
    });
}

/*
    Update the given project's status
*/
async function updateTesterProjectStatus(testerId, gameId, newStatus) {
    return new Promise((resolve, reject) => {
      db.collection("Game").doc(gameId).get()
        .then(doc => {
          if (!doc.exists) {
            reject({ success: false, error: "game does not exist" });
          }

          const gameTesterIDs = doc.data().testerIDs;
          const gameTesterStatuses = doc.data().testerStatuses;
          gameTesterStatuses[gameTesterIDs.indexOf(testerId)] = newStatus;

          db.collection("Game").doc(gameId)
            .update({
                testerStatuses: gameTesterStatuses
            }).catch(e => reject(err(e)));
        }).catch(e => reject(err(e)));
    });
}

export default {
    createPlayTesterProfile,
    isPlayTesterProfileCompleted,
    createTester,
    getPlayTesterProfile,
    PROFILE_DNE,
    updateTesterFirstTime,
    updateTesterProjectStatus
}



// WEBPACK FOOTER //
// ./src/Firestore/PlayTesterUser.js